module.exports = __webpack_public_path__ + "static/Kisan Network-673d51f3bdbf1d2301a59da2cad68880.jpg";